import {Modal, Image, Button as AntButton} from 'antd';
import {EyeOutlined} from '@ant-design/icons';
import styles from './viewFilesModal.module.scss';

const ViewFilesModal = ({isOpen, onClose, files = []}) => {
  const isImageFile = file => {
    return (
      file?.type?.startsWith('image/') ||
      file?.url?.match(/\.(jpg|jpeg|png|gif|webp|svg)$/i)
    );
  };

  const handleViewFile = file => {
    if (isImageFile(file)) {
      // Images will be handled by the Image component's preview
      return;
    } else {
      // PDFs and docs open in new tab
      window.open(file.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      title="Uploaded Files"
      width={600}
      centered>
      <div className={styles.filesList}>
        {files.length === 0 ? (
          <p className={styles.noFiles}>No files available</p>
        ) : (
          files.map((file, index) => (
            <div key={index} className={styles.fileItem}>
              <div className={styles.fileInfo}>
                <span className={styles.fileName}>
                  {file.name || `File ${index + 1}`}
                </span>
                {file.type && (
                  <span className={styles.fileType}>{file.type}</span>
                )}
              </div>
              <div className={styles.fileActions}>
                {isImageFile(file) ? (
                  <Image
                    width={100}
                    height={100}
                    src={file.url}
                    alt={file.name || 'Uploaded image'}
                    style={{
                      objectFit: 'cover',
                      borderRadius: '4px',
                      cursor: 'pointer',
                    }}
                    preview={false}
                    onClick={() =>
                      window.open(file.url, '_blank', 'noopener,noreferrer')
                    }
                    fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3Ik1RnG4W+FgYxN"
                  />
                ) : (
                  <AntButton
                    type="primary"
                    icon={<EyeOutlined />}
                    onClick={() => handleViewFile(file)}>
                    View File
                  </AntButton>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </Modal>
  );
};

export default ViewFilesModal;
